module.exports = __webpack_public_path__ + "img/mode2-6.96c1ee39.png";